import styled from '@emotion/styled/macro'
import { fontSize, size } from '@styles/theme'

import logoLargeWhite from '@assets/images/mandrake-logo-large-white.svg'

const LogoImg = styled.img`
  height: ${size(15)};
  width: ${size(15)};
`

const LogoText = styled.p`
  display: flex;
  align-items: center;
  padding: 0;
  margin: ${size(3)} auto 10vh auto;
  font-weight: bold;
  font-size: ${fontSize('sm')};
`

const LoaderLogo = ({ children, slotProps={ text: {}, img: {} } }) => {
  return (
    <>
      <LogoImg
        src={logoLargeWhite}
        alt='Mandrake Logo'
        {...slotProps?.img}
      />
      <LogoText {...slotProps?.text} >
        {children}
      </LogoText>
    </>
  )
}

export { LoaderLogo }
